<template>
  <div>
    <div>
      <!-- <div class="switchBox">
        <el-radio-group
          size="mini"
          v-model="roleType"
          style="padding: 0.5rem 0"
          @change="roleTypeRadioChange"
        >
          <el-radio-button
            :disabled="!hospitalTypeFlag"
            label="医院"
          ></el-radio-button>
          <el-radio-button
            :disabled="!groupTypeFlag"
            label="集团"
          ></el-radio-button>
        </el-radio-group>
      </div> -->

      <div v-show="hospitalTypeFlag">
        <el-row gutter="10">
          <!-- 通知 -->
          <el-col span="8">
            <div class="announce">
              <div
                style="
                  background-color: #fff;
                  box-sizing: border-box;
                  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
                  padding: 10px;
                "
              >
                <div class="announce-title">
                  <span class="announce-title-text">
                    <i class="el-icon-bell"></i>通知公告</span
                  >
                  <span class="announce-title-more" @click="noticeMore"
                    >更多 ></span
                  >
                </div>
                <div
                  class="announce-content"
                  style="height: 110px; overflow: auto"
                >
                  <div v-if="notices.length == 0" class="announce-content-item">
                    <el-text>暂无公告...</el-text>
                  </div>

                  <div
                    class="announce-content-item"
                    v-for="(item, index) in notices"
                    :key="index"
                    @click="handleNoticeDetailShow(item)"
                  >
                    <el-tooltip :content="item.title" placement="top">
                      <el-text> {{ index + 1 + "、" + item.title }}</el-text>
                    </el-tooltip>

                    <!-- {{ item.name }}
                    <el-tooltip placement="top">
                      <el-text> {{ item.name }}</el-text>
                    </el-tooltip> -->
                  </div>
                </div>
              </div>

              <div style="margin-top: 10px; box-sizing: border-box">
                <div class="lines" style="height: 156px">
                  <div
                    class="announce-title"
                    style="height: 30px; line-height: 30px"
                  >
                    <span class="announce-title-text">
                      <i class="el-icon-bell"></i>服务台</span
                    >
                  </div>
                  <div id="chart_line" style="width: 100%; height: 156px"></div>
                </div>
              </div>
            </div>
          </el-col>
          <!-- 通知详情弹窗 -->
          <el-dialog
            title="通知详情"
            :visible.sync="noticeDetailShow"
            append-to-body
          >
            <div>
              <div class="detail-item">
                <div class="detail-item-title">标题：</div>
                <div class="detail-item-content">
                  {{ choosen.title }}
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">内容：</div>
                <div class="detail-item-content">
                  <div v-html="choosen.content"></div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">分类：</div>
                <div class="detail-item-content">
                  {{ choosen.categoryName }}
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">创建时间：</div>
                <div class="detail-item-content">
                  {{ choosen.createTime }}
                </div>
              </div>
            </div>
          </el-dialog>

          <!-- 旗帜 -->
          <el-col span="8">
            <div class="flag">
              <div class="chart-title">
                <!-- <span class="chart-title-text">
                    <i class="el-icon-bell"></i>工单处理状态分布图</span
                  > -->
                <span class="chart-title-text">
                  <i class="el-icon-bell"></i>工单状态</span
                >
              </div>
              <avue-data-tabs
                :option="option"
                span="12"
                id="avue-data-tabs"
              ></avue-data-tabs>
            </div>
          </el-col>
          <!-- 图表 -->
          <el-col span="8">
            <div class="carts">
              <div class="chart-title">
                <!-- <span class="chart-title-text">
                    <i class="el-icon-bell"></i>工单处理状态分布图</span
                  > -->
                <span class="chart-title-text">
                  <i class="el-icon-bell"></i>工单类型分布图</span
                >
                <span class="announce-title-more">
                  <el-select
                    @change="handleTimeChange"
                    size="mini"
                    v-model="orderCountCycle"
                  >
                    <el-option value="month" label="最近30天"></el-option>
                    <el-option value="halfYear" label="最近半年"></el-option>
                    <el-option value="year" label="最近1年"></el-option>
                  </el-select>
                </span>
              </div>

              <div
                id="chart"
                style="
                  width: 100%;
                  height: 295px;
                  border-top: 1px solid #efefef;
                "
              ></div>
            </div>
          </el-col>
        </el-row>

        <el-row gutter="10" style="margin-top: 10px">
          <!-- 通知 -->
          <el-col span="8">
            <div class="announce">
              <div
                style="
                  background-color: #fff;
                  box-sizing: border-box;
                  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
                  padding: 10px;
                "
              >
                <div class="announce-title">
                  <span class="announce-title-text">
                    <i class="el-icon-bell"></i>合同统计</span
                  >
                  <!-- <span class="announce-title-more" @click="noticeMore">更多 ></span> -->
                </div>
                <div
                  class="announce-content"
                  style="
                    box-sizing: border-box;
                    padding-top: 22px;
                    overflow: auto;
                  "
                >
                  <div
                    style="
                      color: #fff;
                      border: 1px solid #eaeaea;
                      height: 150px;
                      padding: 15px 15px;
                      box-sizing: border-box;
                      background-color: rgb(178, 159, 255);
                      border-radius: 5px;
                    "
                  >
                    <div style="font-size: 0.8rem">付款合同</div>
                    
                      <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: calc(80% - 5px);
                      ">
                    <div style="display: flex;width:100%;">
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.unhandleData }}
                          </div>
                          <div style="font-size: 0.8rem">未履行</div>
                        </div>
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.handleData }}
                          </div>
                          <div style="font-size: 0.8rem">履行中</div>
                        </div>
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.deadlineData }}
                          </div>
                          <div style="font-size: 0.8rem">已到期</div>
                        </div>
                      </div>
                    
                    </div>


                  </div>
                  <div
                    style="
                      color: #fff;
                      border: 1px solid #eaeaea;
                      height: 150px;
                      padding: 15px 15px;
                      box-sizing: border-box;
                      background-color: rgb(27, 201, 142);
                      border-radius: 5px;
                      margin-top: 1rem;
                    "
                  >
                    <div style="font-size: 0.8rem">收款合同</div>

                    
                    
                      <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: calc(80% - 5px);
                      ">
                    <div style="display: flex;width:100%;">
                            <div style="flex: 1; text-align: center">
                              <div style="font-size: 2.5rem; font-weight: bold">
                                {{ contractData.unhandleIncomeData }}
                              </div>
                              <div style="font-size: 0.8rem">未履行</div>
                            </div>
                            <div style="flex: 1; text-align: center">
                              <div style="font-size: 2.5rem; font-weight: bold">
                                {{ contractData.handleIncomeData }}
                              </div>
                              <div style="font-size: 0.8rem">履行中</div>
                            </div>
                            <div style="flex: 1; text-align: center">
                              <div style="font-size: 2.5rem; font-weight: bold">
                                {{ contractData.deadlineIncomeData }}
                              </div>
                              <div style="font-size: 0.8rem">已到期</div>
                            </div>
                          </div>

                    
                    </div>

                  </div>
                  <!-- <div
                      class="announce-content-item"
                      v-for="(item, index) in notices"
                      :key="index"
                      @click="handleNoticeDetailShow(item)"
                    >
                      <el-tooltip :content="item.title" placement="top">
                        <el-text> {{ index + 1 + "、" + item.title }}</el-text>
                      </el-tooltip>
                    </div> -->
                </div>
              </div>

              <!-- <div style="margin-top:.5rem;">
                  <div class="lines">
                    <div
                      id="chart_line"
                      style="width: 100%; height: 178px;"
                    ></div>
                  </div>
                </div> -->
            </div>
          </el-col>

          <!-- 图表 -->
          <el-col span="8">
            <div class="carts">
              <div class="chart-title">
                <!-- <span class="chart-title-text">
                    <i class="el-icon-bell"></i>工单处理状态分布图</span
                  > -->
                <span class="chart-title-text">
                  <i class="el-icon-bell"></i>设备统计</span
                >
              </div>
              <div
                style="
                  overflow: hidden;
                  box-sizing: border-box;
                  padding: 1rem 1rem;
                "
              >
                <div style="float: left">
                  <div>设备资产</div>
                  <div>设施设备台账总数</div>
                </div>
                <div style="float: right; font-size: 2rem; font-weight: bold">
                  {{ deviceTotal }}
                </div>
              </div>
              <div
                id="chart_line_horizon"
                style="
                  width: 100%;
                  height: 262px;
                  border-top: 1px solid #efefef;
                "
              ></div>
            </div>
          </el-col>

          <!-- 通知 -->
          <el-col span="8">
            <div class="announce" style="height: 210px">
              <div style="">
                <div class="lines" style="height: 180px">
                  <div
                    class="announce-title"
                    style="height: 30px; line-height: 30px"
                  >
                    <span class="announce-title-text">
                      <i class="el-icon-bell"></i>问卷统计</span
                    >
                  </div>
                  <div
                    id="chart_line_basic"
                    style="width: 100%; height: 180px"
                  ></div>
                </div>
              </div>

              <div style="margin-top: 0.5rem">
                <div class="lines" style="height: 180px">
                  <div
                    class="announce-title"
                    style="height: 30px; line-height: 30px"
                  >
                    <span class="announce-title-text">
                      <i class="el-icon-bell"></i>考核统计</span
                    >
                  </div>
                  <div
                    id="chart_line_basic_"
                    style="width: 100%; height: 180px"
                  ></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div v-show="groupTypeFlag">
        <el-row gutter="10" :style="`height:${halfHeight}px;`">
          <!-- 通知 -->
          <el-col span="8" style="height:100%;margin-bottom:0">
            <div class="announce" style="height: 100%">
              <div
                style="
                  background-color: #fff;
                  box-sizing: border-box;
                  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
                  padding: 10px;
                  height:calc(50% - 5px)
                "
              >
                <div class="announce-title">
                  <span class="announce-title-text">
                    <i class="el-icon-bell"></i>成员医院
                  </span>
                  <!-- <span class="announce-title-more" @click="noticeMore">更多 ></span> -->
                </div>
                <div
                  class="announce-content"
                  style="height: calc(100% - 50px); overflow: auto"
                >
                  <div
                    class="announce-content-item"
                    :class="{
                      'announce-content-item-active': item.id == projectId,
                    }"
                    v-for="(item, index) in projectList"
                    :key="index"
                    @click="changeProject(item)"
                  >
                    <el-text> {{ item.name }}</el-text>
                  </div>
                </div>
              </div>
              <!-- <div>
                  <div class="lines">
                    <div
                      id="chart_line_"
                      style="width: 100%; height: 178px;"
                    ></div>
                  </div>
                </div> -->

              <div
                style="
                margin-top:10px;
                  background-color: #fff;
                  box-sizing: border-box;
                  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
                  padding: 10px;
                  height:calc(50% - 5px)
                "
              >
                <div class="announce-title">
                  <span class="announce-title-text">
                    <i class="el-icon-bell"></i>通知公告</span
                  >
                  <span class="announce-title-more" @click="noticeMore"
                    >更多 ></span
                  >
                </div>
                <div
                  class="announce-content"
                  style="height: calc(100% - 50px); overflow: auto"
                >
                  <div v-if="notices.length == 0" class="announce-content-item">
                    <el-text>暂无公告...</el-text>
                  </div>
                  <div
                    class="announce-content-item"
                    v-for="(item, index) in notices"
                    :key="index"
                    @click="handleNoticeDetailShow(item)"
                  >
                    <el-tooltip :content="item.title" placement="top">
                      <el-text> {{ index + 1 + "、" + item.title }}</el-text>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <!-- 通知详情弹窗 -->
          <el-dialog
            title="通知详情"
            :visible.sync="noticeDetailShow"
            append-to-body
          >
            <div>
              <div class="detail-item">
                <div class="detail-item-title">标题：</div>
                <div class="detail-item-content">
                  {{ choosen.title }}
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">内容：</div>
                <div class="detail-item-content">
                  <div v-html="choosen.content"></div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">分类：</div>
                <div class="detail-item-content">
                  {{ choosen.categoryName }}
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-item-title">创建时间：</div>
                <div class="detail-item-content">
                  {{ choosen.createTime }}
                </div>
              </div>
            </div>
          </el-dialog>

          <el-col span="16" style="height:100%;margin-bottom:0">
            <div class="carts_" style="height:calc(100% - 20px)">
              <div class="chart-title">
                <span class="chart-title-text">
                  <i class="el-icon-bell"></i>价值分析</span
                >
              </div>
              <div style="position: relative;height:calc(100% - 50px)">
                <div class="year-picker">
                  <el-select
                    v-model="year"
                    @change="yearChange"
                    placeholder="请选择"
                    size="mini"
                  >
                    <el-option
                      v-for="item in years"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <!-- <el-date-picker
                    v-model="year"
                    type="year"
                    placeholder="请选择"
                    :clearable="false"
                    size="mini"
                    value-format="yyyy"
                  >
                  </el-date-picker> -->
                </div>
                <div
                  id="chart_line_bar"
                  style="
                    width: 100%;
                    height: 100%;
                    border-top: 1px solid #efefef;
                  "
                ></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="height:10px"></div>
        <el-row gutter="10" :style="`height:${halfHeight}px;`">
          <!--  -->
          <el-col span="8" style="height:100%;margin-bottom:0">
            <div class="announce" style="height:100%;">
              <div
                style="
                  background-color: #fff;
                  box-sizing: border-box;
                  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
                  padding: 10px;
                  height:100%
                "
              >
                <div class="announce-title">
                  <span class="announce-title-text">
                    <i class="el-icon-bell"></i>合同统计</span
                  >
                  <!-- <span class="announce-title-more" @click="noticeMore">更多 ></span> -->
                </div>
                <div
                  class="announce-content"
                  style="
                    box-sizing: border-box;
                    overflow: auto;
                    height:calc(100% - 50px)
                  "
                >
                  <div
                    style="
                      color: #fff;
                      border: 1px solid #eaeaea;
                      height: calc(50% - 5px);
                      padding: 10px 15px;
                      box-sizing: border-box;
                      background-color: rgb(178, 159, 255);
                      border-radius: 5px;
                    "
                  >
                    <div style="font-size: 0.8rem">付款合同</div>
                    
                      <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: calc(80% - 5px);
                      ">
                    <div style="display: flex;width:100%;">
                      <div style="flex: 1; text-align: center">
                        <div style="font-size: 2.5rem; font-weight: bold">
                          {{ contractData.unhandleData }}
                        </div>
                        <div style="font-size: 0.8rem">未履行</div>
                      </div>
                      <div style="flex: 1; text-align: center">
                        <div style="font-size: 2.5rem; font-weight: bold">
                          {{ contractData.handleData }}
                        </div>
                        <div style="font-size: 0.8rem">履行中</div>
                      </div>
                      <div style="flex: 1; text-align: center">
                        <div style="font-size: 2.5rem; font-weight: bold">
                          {{ contractData.deadlineData }}
                        </div>
                        <div style="font-size: 0.8rem">已到期</div>
                      </div>
                    </div>

                      </div>
                  </div>
                  <div
                    style="
                      color: #fff;
                      border: 1px solid #eaeaea;
                     height: calc(50% - 5px);
                      padding: 10px 15px;
                      box-sizing: border-box;
                      background-color: rgb(27, 201, 142);
                      border-radius: 5px;
                      margin-top: 10px;
                    "
                  >
                    <div style="font-size: 0.8rem">收款合同</div>
                      <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: calc(80% - 5px);
                      ">
                      <div style="display: flex;width:100%;">
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.unhandleIncomeData }}
                          </div>
                          <div style="font-size: 0.8rem">未履行</div>
                        </div>
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.handleIncomeData }}
                          </div>
                          <div style="font-size: 0.8rem">履行中</div>
                        </div>
                        <div style="flex: 1; text-align: center">
                          <div style="font-size: 2.5rem; font-weight: bold">
                            {{ contractData.deadlineIncomeData }}
                          </div>
                          <div style="font-size: 0.8rem">已到期</div>
                        </div>
                      </div>

                    
                    </div>
                  </div>
                  <!-- <div
                      class="announce-content-item"
                      v-for="(item, index) in notices"
                      :key="index"
                      @click="handleNoticeDetailShow(item)"
                    >
                      <el-tooltip :content="item.title" placement="top">
                        <el-text> {{ index + 1 + "、" + item.title }}</el-text>
                      </el-tooltip>
                    </div> -->
                </div>
              </div>

              <!-- <div style="margin-top:.5rem;">
                  <div class="lines">
                    <div
                      id="chart_line"
                      style="width: 100%; height: 178px;"
                    ></div>
                  </div>
                </div> -->
            </div>
          </el-col>
          <!--  -->
          <el-col span="8" style="height:100%;margin-bottom:0">
            <div class="carts" style="height:calc(100% - 20px)">
              <div class="chart-title">
                <!-- <span class="chart-title-text">
                    <i class="el-icon-bell"></i>工单处理状态分布图</span
                  > -->
                <span class="chart-title-text">
                  <i class="el-icon-bell"></i>设备统计</span
                >
              </div>
              <div
                style="
                  overflow: hidden;
                  box-sizing: border-box;
                  height:60px
                "
              >
                <div style="float: left">
                  <div style="height:30px;line-height:40px;padding-left:10px">设备资产</div>
                  <div style="height:30px;line-height:20px;padding-left:10px">设施设备台账总数</div>
                </div>
                <div style="float: right; font-size: 2rem; font-weight: bold;height:60px;line-height:60px;padding-right:10px">
                  {{ deviceTotal }}
                </div>
              </div>
              <div
                id="_chart_line_horizon"
                style="
                  width: 100%;
                  height: calc(100% - 110px);
                  border-top: 1px solid #efefef;
                "
              ></div>
            </div>
          </el-col>
          <!--  -->
          <el-col span="8" style="height:100%;margin-bottom:0">
            <div class="announce" style="height: 100%">
              <div style="height:calc(50% - 5px)">
                <div class="lines" style="height: calc(100% - 20px);overflow:hidden;">
                  <div
                    class="announce-title"
                    style="height: 30px; line-height: 30px"
                  >
                    <span class="announce-title-text">
                      <i class="el-icon-bell"></i>问卷统计</span
                    >
                  </div>
                  <div
                    id="_chart_line_basic"
                    style="width: 100%; height: 160px"
                  ></div>
                </div>
              </div>

              <div style="margin-top: 10px;height:calc(50% - 5px)">
                <div class="lines" style="height: calc(100% - 20px);overflow:hidden;">
                  <div
                    class="announce-title"
                    style="height: 30px; line-height: 30px"
                  >
                    <span class="announce-title-text">
                      <i class="el-icon-bell"></i>考核统计</span
                    >
                  </div>
                  <div
                    id="_chart_line_basic_"
                    style="width: 100%; height: 160px"
                  ></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { opt_chart } from "./echarts";
import {
  getNotice,
  getProjectList,
  // isGroupView,
  getUserType,
  getOrderTrend,
  getOrderStatusCount,
  getDeviceStatistics,
  getDeviceTotal,
  getOrderTypeCount,
  getContractPayCount,
  getContractIncomeCount,
  getExamineTrendScore,
  getQuestionnaireTrendScore,
  getValue,
} from "@/api/wel/home";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  data() {
    return {
      orderCountCycle: "month",
      projectId: "",
      projectList: [],
      year: "",
      years: [],
      userType: "",
      roleType: "医院",
      hospitalTypeFlag: true,
      groupTypeFlag: false,
      deviceTotal: 0, //设备总数
      option: {
        span: "12",
        data: [
          {
            click: function (item) {},
            title: "",
            subtitle: "数据",
            count: 0,
            // allcount: 10222,
            text: "进行中的工单总数",
            color: "rgb(27, 201, 142)",
            key: "条",
          },
          {
            click: function (item) {},
            title: "",
            subtitle: "数据",
            count: 0,
            // allcount: 10222,
            text: "需要指派的工单数",
            color: "rgb(178, 159, 255)",
            key: "条",
          },
          {
            click: function (item) {},
            title: "",
            subtitle: "数据",
            count: 0,
            // allcount: 10222,
            text: " 待评价的工单数",
            color: "rgb(230, 71, 88)",
            key: "条",
          },
          {
            click: function (item) {},
            title: "",
            subtitle: "数据",
            count: 0,
            // allcount: 10222,
            text: "出现异常的工单数",
            color: "rgb(250, 200, 88)",
            key: "条",
          },
        ],
      },
      notices: [],
      page: { current: 1, size: 10 },
      noticeDetailShow: false,
      choosen: {
        title: "",
        content: "",
        categoryName: "",
        createTime: "",
      },
      contractData: {
        deadlineData: 0,
        unhandleData: 0,
        handleData: 0,
      },
      //
      chart_line: "",
      chart: "",
      chart_line_horizon: "",
      chart_line_basic: "",
      chart_line_basic_: "",
      chart_line_bar: "",
      //
      halfHeight:450
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.year = new Date().getFullYear() + "";
    let tempYear = dayjs().subtract(3, "year").year();
    for (let i = 0; i < 7; i++) {
      this.years.push(tempYear + i + "");
    };
    this.halfHeight = (document.body.clientHeight - 64 - 40 - 30)/2;
  },
  mounted() {
    this.styleReset();
    const deptId = this.userInfo.dept_id;
    // userType:1-成员医院,2-集团
    getUserType({ deptId }).then((res) => {
      this.userType = res.data.userType;
      this.projectList = res.data.projectList;
      this.projectId = this.projectList[0].id;
      if (this.userType == 1) {
        this.roleType = "医院";
        this.hospitalTypeFlag = true;
        this.groupTypeFlag = false;
        this.getOrderStatus();
        this.getOrderCategory();
        this.getOrderTrend();
      } else {
        this.roleType = "集团";
        this.hospitalTypeFlag = false;
        this.groupTypeFlag = true;
        this.getValueAnalysis();
      }
      this.getNotice();
      this.getContract();
      this.getDevice();
      this.getExamineAndQuestionnaire();

      const self = this;
      window.onresize = function () {
        console.log("123==>", 123);
        console.log("this.chart_line==>", self.chart_line.setOption);
        self.chart_line && self.chart_line.resize();
        self.chart && self.chart.resize();
        self.chart_line_horizon && self.chart_line_horizon.resize();
        self.chart_line_basic && self.chart_line_basic.resize();
        self.chart_line_basic_ && self.chart_line_basic_.resize();
        self.chart_line_bar && self.chart_line_bar.resize();
      };
    });
  },
  methods: {
    styleReset() {
      document
        .querySelector('div[id="avue-data-tabs"]')
        .querySelectorAll(".item")
        .forEach((el, index) => {
          el.style.height = "130px";
          el.style.margin = "5px";
        });
      console.log(
        "styleReset=========>",
        document
          .querySelector('div[id="avue-data-tabs"]')
          .querySelectorAll(".item")
      );
    },
    yearChange() {
      this.getValueAnalysis();
    },
    changeProject(item) {
      this.projectId = item.id;
      this.getContract();
      this.getDevice();
      this.getExamineAndQuestionnaire();
      this.getNotice();
    },
    handleTimeChange(val) {
      console.log(val);
      this.orderCountCycle = val;
      this.getOrderCategory();
    },
    //工单状态栏
    getOrderTrend() {
      getOrderTrend({ projectId: this.projectId }).then((res) => {
        console.log("getOrderTrend", res);
        let arr = [];
        let x_arr = [];
        res.data.forEach((element) => {
          arr.push(element.trendCount);
          x_arr.push(element.trendDate);
        });
        opt_chart.line_opt.series[0].data = arr;
        opt_chart.line_opt.xAxis.data = x_arr;
        this.chart_line = echarts.init(document.getElementById("chart_line"));
        this.chart_line.setOption(opt_chart.line_opt);
      });
    },
    //工单状态
    getOrderStatus() {
      getOrderStatusCount({ projectId: this.projectId, status: 1 }).then(
        (res) => {
          console.log(res);
          this.option.data[1].title = "待指派";
          this.option.data[1].count = res.data;
          // this.option.data[1].title = "协助工单";
          // this.option.data[1].count = res.data.helpCount;
          // this.option.data[2].title = "差评工单";
          // this.option.data[2].count = res.data.badEvaluateCount;
          // this.option.data[3].title = "异常工单";
          // this.option.data[3].count = res.data.errorCount;
        }
      );
      getOrderStatusCount({ projectId: this.projectId, status: 4 }).then(
        (res) => {
          console.log(res);
          this.option.data[0].title = "进行中";
          this.option.data[0].count = res.data;
          // this.option.data[1].title = "协助工单";
          // this.option.data[1].count = res.data.helpCount;
          // this.option.data[2].title = "差评工单";
          // this.option.data[2].count = res.data.badEvaluateCount;
          // this.option.data[3].title = "异常工单";
          // this.option.data[3].count = res.data.errorCount;
        }
      );
      getOrderStatusCount({ projectId: this.projectId, status: 7 }).then(
        (res) => {
          console.log(res);
          this.option.data[2].title = "待评价";
          this.option.data[2].count = res.data;
          // this.option.data[1].title = "协助工单";
          // this.option.data[1].count = res.data.helpCount;
          // this.option.data[2].title = "差评工单";
          // this.option.data[2].count = res.data.badEvaluateCount;
          // this.option.data[3].title = "异常工单";
          // this.option.data[3].count = res.data.errorCount;
        }
      );
      getOrderStatusCount({
        projectId: this.projectId,
        status: "abnormal",
      }).then((res) => {
        console.log(res);
        this.option.data[3].title = "异常工单";
        this.option.data[3].count = res.data;
        // this.option.data[1].title = "协助工单";
        // this.option.data[1].count = res.data.helpCount;
        // this.option.data[2].title = "差评工单";
        // this.option.data[2].count = res.data.badEvaluateCount;
        // this.option.data[3].title = "异常工单";
        // this.option.data[3].count = res.data.errorCount;
      });
    },
    //工单类型
    getOrderCategory() {
      getOrderTypeCount({
        projectId: this.projectId,
        cycle: this.orderCountCycle,
      }).then((res) => {
        console.log("res STATUS==>", res);
        let data = res.data;
        let seriesData = [];
        data.forEach((element) => {
          seriesData.push({
            name: element.moduleName,
            value: element.typeCount,
          });
        });

        opt_chart.newline(opt_chart.line_basic_opt, 6, "xAxis");
        opt_chart.newline(opt_chart.line_basic_opt_, 6, "xAxis");
        opt_chart.bar_opt.series[0].data = seriesData;
        this.chart = echarts.init(document.getElementById("chart"));
        this.chart.setOption(opt_chart.bar_opt);
        // this.$nextTick(() => {
        //   window.onresize = function () {
        //     chart.resize();
        //     chart_line.resize();
        //     chart_line_horizon.resize();
        //     chart_line_basic.resize();
        //     chart_line_basic_.resize();
        //     _chart_line_horizon.resize();
        //     _chart_line_basic.resize();
        //     _chart_line_basic_.resize();
        //     chart_line_bar.resize();
        //   };
        // });
      });
    },
    //通知
    getNotice() {
      getNotice({ projectId: this.projectId }).then((res) => {
        this.notices = res.data.records;
      });
    },
    //合同数据
    getContract() {
      getContractPayCount({ projectId: this.projectId, index: 1 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.unhandleData = res.data;
        }
      );
      getContractPayCount({ projectId: this.projectId, index: 2 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.handleData = res.data;
        }
      );
      getContractPayCount({ projectId: this.projectId, index: 4 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.deadlineData = res.data;
        }
      );

      getContractIncomeCount({ projectId: this.projectId, index: 1 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.unhandleIncomeData = res.data;
        }
      );
      getContractIncomeCount({ projectId: this.projectId, index: 2 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.handleIncomeData = res.data;
        }
      );
      getContractIncomeCount({ projectId: this.projectId, index: 4 }).then(
        (res) => {
          console.log("getContractPayCount=======>", res);
          this.contractData.deadlineIncomeData = res.data;
        }
      );
    },
    //问卷和考核
    getExamineAndQuestionnaire() {
      opt_chart.newline(opt_chart.line_basic_opt, 6, "xAxis");
      opt_chart.newline(opt_chart.line_basic_opt_, 6, "xAxis");
      getExamineTrendScore({ projectId: this.projectId }).then((res) => {
        let arr = [];
        let x_arr = [];
        res.data.forEach((element) => {
          arr.push(element.score);
          x_arr.push(element.name);
        });

        opt_chart.line_basic_opt.series[0].data = arr;
        opt_chart.line_basic_opt.xAxis[0].data = x_arr;
        if (this.userType == 1) {
          this.chart_line_basic = echarts.init(
            document.getElementById("chart_line_basic_")
          );
        } else {
          this.chart_line_basic = echarts.init(
            document.getElementById("_chart_line_basic_")
          );
        }
        this.chart_line_basic.setOption(opt_chart.line_basic_opt);
      });

      getQuestionnaireTrendScore({ projectId: this.projectId }).then((res) => {
        let arr = [];
        let x_arr = [];
        res.data.forEach((element) => {
          arr.push(element.score);
          x_arr.push(element.name);
        });
        opt_chart.line_basic_opt_.series[0].data = arr;
        opt_chart.line_basic_opt_.xAxis[0].data = x_arr;
        if (this.userType == 1) {
          this.chart_line_basic_ = echarts.init(
            document.getElementById("chart_line_basic")
          );
        } else {
          this.chart_line_basic_ = echarts.init(
            document.getElementById("_chart_line_basic")
          );
        }
        this.chart_line_basic_.setOption(opt_chart.line_basic_opt_);
      });
    },
    //设备状态
    getDevice() {
      const deviceStatus = [
        { status: 4, label: "报废" },
        { status: 3, label: "维修中" },
        { status: 2, label: "维保中" },
        { status: 1, label: "异常" },
      ];
      let apis = [];
      let yAxisData = [];
      deviceStatus.forEach((item) => {
        let params = {
          projectId: this.projectId,
          status: item.status,
        };
        apis.push(getDeviceStatistics(params));
        yAxisData.push(item.label);
      });
      Promise.all(apis)
        .then((res) => {
          console.log("res all==>", res);
          let seriesData = [];
          res.forEach((item) => {
            seriesData.push(item.data);
          });
          //渲染echart
          opt_chart.line_horizon_opt.yAxis.data = yAxisData;
          opt_chart.line_horizon_opt.series[0].data = seriesData;

          if (this.userType == 1) {
            console.log("1212121212==>", 1212121212);
            this.chart_line_horizon = echarts.init(
              document.getElementById("chart_line_horizon")
            );
          } else {
            this.chart_line_horizon = echarts.init(
              document.getElementById("_chart_line_horizon")
            );
          }
          this.chart_line_horizon.setOption(opt_chart.line_horizon_opt);
        })
        .catch((err) => {
          console.log("err==>", err);
        });
      getDeviceTotal({ projectId: this.projectId }).then((res) => {
        this.deviceTotal = res.data;
      });
    },
    //价值分析
    getValueAnalysis() {
      const types = [
        { type: 1, label: "临床评价值" },
        { type: 2, label: "患者满意度" },
        { type: 3, label: "成本结余" },
        { type: 4, label: "实际创收" },
      ];
      let apis = [];
      types.forEach((item) => {
        const params = {
          year: this.year,
          type: item.type,
        };
        apis.push(getValue(params));
      });
      let clinicalAssessment = [],
        patientSatisfaction = [],
        costSaving = [],
        actualIncome = [];
      let xAxis = [];
      Promise.all(apis).then((res) => {
        res[0].data.forEach((ele) => {
          clinicalAssessment.push(ele.clinicalAssessment);
          xAxis.push(ele.projectName);
        });
        res[1].data.forEach((ele) => {
          patientSatisfaction.push(ele.patientSatisfaction);
        });
        res[2].data.forEach((ele) => {
          costSaving.push(ele.costSaving);
        });
        res[3].data.forEach((ele) => {
          actualIncome.push(ele.actualIncome);
        });
        opt_chart.line_bar_opt.xAxis[0].data = xAxis;
        opt_chart.line_bar_opt.series[0].data = clinicalAssessment;
        opt_chart.line_bar_opt.series[1].data = patientSatisfaction;
        opt_chart.line_bar_opt.series[2].data = costSaving;
        opt_chart.line_bar_opt.series[3].data = actualIncome;
        this.chart_line_bar = echarts.init(
          document.getElementById("chart_line_bar")
        );
        this.chart_line_bar.setOption(opt_chart.line_bar_opt);
      });
    },
    //通知点击查看详情
    handleNoticeDetailShow(item) {
      this.choosen = item;
      this.noticeDetailShow = true;
    },
    //通知:点击更多
    noticeMore() {
      this.$router.push({
        path: `/crmedical/notice/v4ward-notice`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-top {
  display: flex;
  justify-content: space-between;
}
.announce {
  // width: 25%;
  // background-color: #fff;
  // box-sizing: border-box;
  // box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
  // padding: 10px;
  .announce-title {
    display: flex;
    justify-content: space-between;
    height: 50px;
    line-height: 50px;
    .announce-title-text {
      padding-left: 10px;
      font-size: 16px;
      font-weight: bold;
      i {
        margin-right: 10px;
      }
    }
    .announce-title-more {
      font-size: 13px;
      color: #333;
    }
    .announce-title-more:hover {
      cursor: pointer;
    }
  }
  .announce-content {
    .announce-content-item {
      position: relative;
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      border-top: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .announce-content-item:last-child {
      border-bottom: 1px solid #eee;
    }
    .announce-content-item-active {
      cursor: pointer;
      background-color: #efefef;
    }
    .announce-content-item-active::before {
      content: " ";
      position: absolute;
      top: 5px;
      left: 0;
      height: 25px;
      width: 5px;
      background-color: #409eff;
    }
  }
}
.chart-title {
  display: flex;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  .chart-title-text {
    padding-left: 10px;
    font-size: 16px;
    font-weight: bold;
    i {
      margin-right: 10px;
    }
  }
}
.flag {
  background-color: #fff;
  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
  padding: 10px;
}
.carts {
  background-color: #fff;
  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
  padding: 10px;
}
.carts_ {
  background-color: #fff;
  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
  padding: 10px;
}
.lines {
  background-color: #fff;
  box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.06);
  padding: 10px;
}
//
.detail-item {
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #efefef;
  .detail-item-content {
    min-height: 50px;
    line-height: 50px;
    width: 80%;
  }
  .detail-item-title {
    min-height: 50px;
    line-height: 50px;
    width: 20%;
  }
}
.year-picker {
  position: absolute;
  top: 8px;
  left: 3%;
  z-index: 10;
}
#avue-data-tabs .item {
  height: 130px !important;
}
</style>
